import * as React from 'react';
import { offersInitialState, reducer } from './reducer';
import { setComparisonStatus, setContact, setError, setFavoriteStatus, setLayout, setLoading } from './actions';
import { fetchOffers } from '../../services/offers';
import { NewbuildingLayoutsContext } from '../../shared/context';
export function useOffers(_ref) {
  let {
    newbuildingId,
    houseId,
    layoutKey
  } = _ref;
  const {
    httpApi,
    logger
  } = React.useContext(NewbuildingLayoutsContext);
  const [state, dispatch] = React.useReducer(reducer, offersInitialState);
  const setOfferComparisonStatus = React.useCallback((offerId, status) => {
    dispatch(setComparisonStatus(offerId, status));
  }, []);
  const setOfferFavoriteStatus = React.useCallback((offerId, isFavorite) => {
    dispatch(setFavoriteStatus(offerId, isFavorite));
  }, []);
  const fetchLayout = React.useCallback(params => {
    dispatch(setLoading(true));
    dispatch(setError(false));
    fetchOffers({
      params,
      httpApi,
      logger
    }).then(layout => {
      dispatch(setLoading(false));
      if (!layout) {
        dispatch(setError(true));
        return;
      }
      const contact = layout.contacts.length === 1 ? layout.contacts[0] : null;
      dispatch(setLayout(layout));
      dispatch(setContact(contact));
    });
  }, []);
  const onRetry = React.useCallback(() => {
    if (!layoutKey) {
      return;
    }
    fetchLayout({
      newbuildingId,
      houseId,
      layoutKey
    });
  }, [newbuildingId, houseId, layoutKey]);
  React.useEffect(() => {
    if (!layoutKey) {
      return;
    }
    fetchLayout({
      newbuildingId,
      houseId,
      layoutKey
    });
  }, [layoutKey]);
  return {
    layout: state.layout,
    contact: state.contact,
    loading: state.loading,
    error: state.error,
    onRetry,
    setComparisonStatus: setOfferComparisonStatus,
    setFavoriteStatus: setOfferFavoriteStatus
  };
}